import { Controller } from "@hotwired/stimulus"

/**
 * Prefill Date Controller
 * Loads time sheet data into the time_sheets_prefilled block via fetch POST,
 * or appends the date to the new-report link for unsaved reports.
 */
export default class extends Controller {
  static targets = ["dateInput", "link"]
  static values = { errorMessage: String }

  async loadPrefill(event) {
    event.preventDefault()

    const button = event.currentTarget
    const prefillUrl = button.dataset.prefillUrl
    if (!prefillUrl) return

    const url = new URL(prefillUrl, window.location.origin)
    if (this.hasDateInputTarget) {
      url.searchParams.set("prefill_date", this.dateInputTarget.value)
    }

    button.disabled = true

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "X-CSRF-Token": this.csrfToken,
          Accept: "text/vnd.turbo-stream.html",
        },
      })

      if (!response.ok) throw new Error("Prefill failed")

      const html = await response.text()
      Turbo.renderStreamMessage(html)
    } catch (error) {
      console.error("Error loading time sheets:", error)
      alert(this.errorMessageValue || "Fehler beim Laden der Zeiterfassung.")
    } finally {
      button.disabled = false
    }
  }

  appendDate(_event) {
    if (!this.hasDateInputTarget || !this.hasLinkTarget) return

    const date = this.dateInputTarget.value
    const url = new URL(this.linkTarget.href, window.location.origin)
    url.searchParams.set("prefill_date", date)
    this.linkTarget.href = url.toString()
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content
  }
}
